module.exports = __webpack_public_path__ + "stylesheets/both-landings-common_356a51c67634f9ce784848d77ac740a3.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/both-landings-common.less
// module id = vzSK
// module chunks = 51